export default "__VITE_ASSET__Cxha7onq__"